import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import { useState } from "react";

import Home from "./Components/home";
import About from "./Components/about";
import Products from "./Components/products";
import Services from "./Components/services";
import Contact from "./Components/contact";

import logo from "./images/starking-logo.jpg";

import "./App.css";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="App">
      <Router>
        <header className="header">
          <img src={logo} alt="Logo" className="logo" />

          {/* Hamburger Icon */}
          <div
            className="menu-icon"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </div>

          {/* Navigation Menu */}
          <nav className={`nav ${menuOpen ? "nav-open" : "nav-close"}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>HOME</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>ABOUT US</Link>
            <Link to="/products" onClick={() => setMenuOpen(false)}>PRODUCTS</Link>
            <Link to="/services" onClick={() => setMenuOpen(false)}>SERVICES</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>CONTACT US</Link>
          </nav>
        </header>

        <p style={{ marginBottom: "80px" }}></p>

        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/products" element={<Products />} />
          <Route exact path="/services" element={<Services />} />
          <Route exact path="/contact" element={<Contact />} />
        </Routes>

        <p style={{ marginTop: "50px" }}></p>

        <footer>
          <nav>
            <Link to="/">HOME</Link>
            <Link to="/about">ABOUT US</Link>
            <Link to="/products">PRODUCTS</Link>
            <Link to="/services">SERVICES</Link>
            <Link to="/contact">CONTACT US</Link>
          </nav>
        </footer>

        <footerMobile>
          <span>
            <i  class="bx bxs-copyright">&nbsp;
              <span>
                2025 Starking Insulation | 
                Insulation Services and Products <br/>
                <hr/>
                Designed and developed by <a href="https://www.saindia.in" target="_blank" rel="noopener noreferrer">saIndia IT Services</a>
              </span>
              </i>
            </span>
        </footerMobile>
      </Router>
    </div>
  );
}

export default App;
